module.exports = __webpack_public_path__ + "static/media/11.4bb21c02.jpg";